import React from 'react';
import { motion } from 'framer-motion';
import { STACK_LAYERS } from '../data/capabilities';
import { useExplore } from '../context/ExploreContext';
import AnimatedSection from './AnimatedSection';
import './StackOwned.css';

const StackOwned = () => {
  const { stackUnlocked, exploredCount, pillarIds } = useExplore();

  return (
    <section className="stack-owned section" id="stack">
      <div className="container">
        <AnimatedSection>
          <p className="section-label">/ Tech stack</p>
          <h2 className="section-title">
            The full stack.
            <br />
            Owned at every layer.
          </h2>
          <p className="section-subtitle">
            {stackUnlocked
              ? 'You have explored every capability. Here is how the layers connect.'
              : `Explore all ${pillarIds.length} capabilities to unlock the full diagram (${exploredCount}/${pillarIds.length}).`}
          </p>
        </AnimatedSection>

        <div className={`stack-layers ${stackUnlocked ? 'unlocked' : 'locked'}`}>
          {STACK_LAYERS.map((layer, i) => (
            <motion.div
              key={layer.id}
              className="stack-layer"
              initial={false}
              animate={{
                opacity: stackUnlocked ? 1 : 0.45 + i * 0.08,
                y: 0,
              }}
              transition={{ delay: stackUnlocked ? i * 0.08 : 0 }}
            >
              <span className="stack-layer-index">0{i + 1}</span>
              <div>
                <h3>{layer.title}</h3>
                <p>{layer.detail}</p>
              </div>
            </motion.div>
          ))}
          {!stackUnlocked && (
            <div className="stack-lock-note" aria-hidden="true">
              Keep exploring to highlight every layer
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default StackOwned;
